export default ({
    wrapper: {
        overflow: 'auto',
        whiteSpace: 'nowrap',
        margin: '50px 20px 50px 0'
    }
});
